<template>
    <div v-if="row">
        <b-modal id="beneficiario-import-form" centered body-class="body-class container editar-beneficiario-form" size="lg" :visible="true"
		no-close-on-backdrop no-close-on-esc @hidden="$emit('close')">
            <template #modal-title >
				<div class="sub-title">
					<DynamicIcon icon="pencil" :classString="'container-modal-title-icon mr-2'"/>
					<span>Editar Beneficiário</span>
				</div>
            </template>

			<b-list-group class="global-errors" v-if="row.errors && row.errors.errors">
				<b-list-group-item  variant="danger" v-for="globalError in row.errors.errors" :key="globalError">
					{{globalError}}
				</b-list-group-item>
			</b-list-group>

			<div class="row">
				<div class="col-6"> 
					<b-form-group :label-for="getKey('empresaId')+'_id'">
						<label>{{getLabel('empresaId')}}<span class="span-required"> *</span></label>
						<b-form-input required readonly :id="getKey('empresaId')+'_id'" :state="getState(getKey('empresaId'))" v-model="row.empresaId" trim maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('empresaId'))" v-for="error in getErrors(getKey('empresaId'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
				<div class="col-6"> 
					<b-form-group :label-for="getKey('tipoBeneficiario')+'_id'">
						<label>{{getLabel('tipoBeneficiario')}}<span class="span-required"> *</span></label>
						<b-form-select required :id="getKey('tipoBeneficiario')+'_id'" :state="getState(getKey('tipoBeneficiario'))" v-model="row.tipoBeneficiario" :options="tipoOptions"></b-form-select>
						<b-form-invalid-feedback :state="getState(getKey('tipoBeneficiario'))" v-for="error in getErrors(getKey('tipoBeneficiario'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
			</div>

			<div class="row">
				<div class="col-6"> 
					<b-form-group :label="getLabel('cpfTitular')" :label-for="getKey('cpfTitular')+'_id'">
						<b-form-input :id="getKey('cpfTitular')+'_id'" :state="getState(getKey('cpfTitular'))" v-model="row.cpfTitular" trim v-mask="['###.###.###-##']" maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('cpfTitular'))" v-for="error in getErrors(getKey('cpfTitular'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
				<div class="col-6"> 
					<b-form-group :label="getLabel('parentesco')" :label-for="getKey('parentesco')+'_id'">
						<b-form-select :id="getKey('parentesco')+'_id'" :state="getState(getKey('parentesco'))" v-model="row.parentesco" :options="parentescoOptions"></b-form-select>
						<b-form-invalid-feedback :state="getState(getKey('parentesco'))" v-for="error in getErrors(getKey('parentesco'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
			</div>

			<div class="row">
				<div class="col-6"> 
					<b-form-group :label-for="getKey('cpf')+'_id'">
						<label>{{getLabel('cpf')}}<span class="span-required"> *</span></label>
						<b-form-input :id="getKey('cpf')+'_id'" :state="getState(getKey('cpf'))" v-model="row.cpf" trim v-mask="['###.###.###-##']" maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('cpf'))" v-for="error in getErrors(getKey('cpf'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
				<div class="col-6"> 
					<b-form-group :label-for="getKey('nome')+'_id'">
						<label>{{getLabel('nome')}}<span class="span-required"> *</span></label>
						<b-form-input :id="getKey('nome')+'_id'" :state="getState(getKey('nome'))" v-model="row.nome" trim maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('nome'))" v-for="error in getErrors(getKey('nome'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
			</div>

			<div class="row">
				<div class="col-4"> 
					<b-form-group :label-for="getKey('dataNascimento')+'_id'">
						<label>{{getLabel('dataNascimento')}}<span class="span-required"> *</span></label>
						<InputDate2 label="" :id="getKey('dataNascimento')+'_id'" :state="getState(getKey('dataNascimento'))" v-model="row.dataNascimento"/>
						<b-form-invalid-feedback :state="getState(getKey('dataNascimento'))" v-for="error in getErrors(getKey('dataNascimento'))" :key="error">{{error}}</b-form-invalid-feedback>
					
					</b-form-group>
				</div>
				<div class="col-4"> 
					<b-form-group :label="getLabel('genero')" :label-for="getKey('genero')+'_id'">
						<b-form-select :id="getKey('genero')+'_id'" :state="getState(getKey('genero'))" v-model="row.genero" :options="sexoOptions"></b-form-select>
                
						<b-form-invalid-feedback :state="getState(getKey('genero'))" v-for="error in getErrors(getKey('genero'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
				<div class="col-4"> 
					<b-form-group :label="getLabel('estadoCivil')" :label-for="getKey('estadoCivil')+'_id'">
						<b-form-select :id="getKey('estadoCivil')+'_id'" :state="getState(getKey('estadoCivil'))" v-model="row.estadoCivil" :options="estadoCivilOptions"></b-form-select>
						<b-form-invalid-feedback :state="getState(getKey('estadoCivil'))" v-for="error in getErrors(getKey('estadoCivil'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
			</div>

			<div class="row">
				<div class="col-6"> 
					<b-form-group :label="getLabel('localTrabalho')" :label-for="getKey('localTrabalho')+'_id'">
						<b-form-input :id="getKey('localTrabalho')+'_id'" :state="getState(getKey('localTrabalho'))" v-model="row.localTrabalho" trim maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('localTrabalho'))" v-for="error in getErrors(getKey('localTrabalho'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
				<div class="col-6"> 
					<b-form-group :label="getLabel('unidade')" :label-for="getKey('unidade')+'_id'">
						<b-form-input :id="getKey('unidade')+'_id'" :state="getState(getKey('unidade'))" v-model="row.unidade" trim maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('unidade'))" v-for="error in getErrors(getKey('unidade'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
			</div>

			<div class="row">
				<div class="col-6">
					<b-form-group :label-for="getKey('cnpjFaturamento')+'_id'">
						<label>{{getLabel('cnpjFaturamento')}}<span class="span-required"> *</span></label>
						<b-form-input :id="getKey('cnpjFaturamento')+'_id'" :state="getState(getKey('cnpjFaturamento'))" v-model="row.cnpjFaturamento" trim v-mask="['##.###.###/####-##']" maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('cnpjFaturamento'))" v-for="error in getErrors(getKey('cnpjFaturamento'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
				<div class="col-6"> 
					<b-form-group :label="getLabel('dataAdmissao')" :label-for="getKey('dataAdmissao')+'_id'">
						<InputDate2 label="" :id="getKey('dataAdmissao')+'_id'" :state="getState(getKey('dataAdmissao'))" v-model="row.dataAdmissao"/>
						<b-form-invalid-feedback :state="getState(getKey('dataAdmissao'))" v-for="error in getErrors(getKey('dataAdmissao'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
			</div>


			<div class="row">
				<div class="col-12"> 
					<b-form-group :label="getLabel('endereco')" :label-for="getKey('endereco')+'_id'">
						<b-form-input :id="getKey('endereco')+'_id'" :state="getState(getKey('endereco'))" v-model="row.endereco" trim maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('endereco'))" v-for="error in getErrors(getKey('endereco'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
			</div>

			<div class="row">
				<div class="col-6"> 
					<b-form-group :label="getLabel('bairro')" :label-for="getKey('bairro')+'_id'">
						<b-form-input :id="getKey('bairro')+'_id'" :state="getState(getKey('bairro'))" v-model="row.bairro" trim maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('bairro'))" v-for="error in getErrors(getKey('bairro'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
				<div class="col-6"> 
					<b-form-group :label="getLabel('cep')" :label-for="getKey('cep')+'_id'">
						<b-form-input :id="getKey('cep')+'_id'" :state="getState(getKey('cep'))" v-model="row.cep" trim maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('cep'))" v-for="error in getErrors(getKey('cep'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
			</div>

			<div class="row">
				<div class="col-6"> 
					<b-form-group :label="getLabel('estado')" :label-for="getKey('estado')+'_id'">
						<b-form-input :id="getKey('estado')+'_id'" :state="getState(getKey('estado'))" v-model="row.estado" trim maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('estado'))" v-for="error in getErrors(getKey('estado'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
				<div class="col-6"> 
					<b-form-group :label="getLabel('cidade')" :label-for="getKey('cidade')+'_id'">
						<b-form-input :id="getKey('cidade')+'_id'" :state="getState(getKey('cidade'))" v-model="row.cidade" trim maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('cidade'))" v-for="error in getErrors(getKey('cidade'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
			</div>


			<div class="row">
				<div class="col-4"> 
					<b-form-group :label="getLabel('telefoneResidencial')" :label-for="getKey('telefoneResidencial')+'_id'">
						<b-form-input :id="getKey('telefoneResidencial')+'_id'" :state="getState(getKey('telefoneResidencial'))" v-model="row.telefoneResidencial" trim v-mask="['(##) ####-####']" maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('telefoneResidencial'))" v-for="error in getErrors(getKey('telefoneResidencial'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
				<div class="col-4"> 
					<b-form-group :label="getLabel('telefoneComercial')" :label-for="getKey('telefoneComercial')+'_id'">
						<b-form-input :id="getKey('telefoneComercial')+'_id'" :state="getState(getKey('telefoneComercial'))" v-model="row.telefoneComercial" trim v-mask="['(##) ####-####']" maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('telefoneComercial'))" v-for="error in getErrors(getKey('telefoneComercial'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
				<div class="col-4"> 
					<b-form-group :label="getLabel('telefoneCelular')" :label-for="getKey('telefoneCelular')+'_id'">
						<b-form-input :id="getKey('telefoneCelular')+'_id'" :state="getState(getKey('telefoneCelular'))" v-model="row.telefoneCelular" trim v-mask="['(##) #####-####']" maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('telefoneCelular'))" v-for="error in getErrors(getKey('telefoneCelular'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
			</div>


			<div class="row">
				<div class="col-6"> 
					<b-form-group :label="getLabel('email1')" :label-for="getKey('email1')+'_id'">
						<b-form-input :id="getKey('email1')+'_id'" :state="getState(getKey('email1'))" v-model="row.email1" trim maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('email1'))" v-for="error in getErrors(getKey('email1'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
				<div class="col-6"> 
					<b-form-group :label="getLabel('email2')" :label-for="getKey('email2')+'_id'">
						<b-form-input :id="getKey('email2')+'_id'" :state="getState(getKey('email2'))" v-model="row.email2" trim maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('email2'))" v-for="error in getErrors(getKey('email2'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
			</div>

			<div class="row" v-if="isNR01">
					<div class="col-6">
						<b-form-group :label="getLabel('ghe')" :label-for="getKey('ghe')+'_id'">
							<b-form-input :id="getKey('ghe')+'_id'" :state="getState(getKey('ghe'))" v-model="row.ghe" trim maxlength="150"/>
							<b-form-invalid-feedback :state="getState(getKey('ghe'))" v-for="error in getErrors(getKey('ghe'))" :key="error">{{error}}</b-form-invalid-feedback>
						</b-form-group>
					</div>

					<div class="col-6">
						<b-form-group :label="getLabel('setor')" :label-for="getKey('setor')+'_id'">
							<b-form-input :id="getKey('setor')+'_id'" :state="getState(getKey('setor'))" v-model="row.setor" trim maxlength="150"/>
							<b-form-invalid-feedback :state="getState(getKey('setor'))" v-for="error in getErrors(getKey('setor'))" :key="error">{{error}}</b-form-invalid-feedback>
						</b-form-group>
					</div>
			</div>

			<div class="row" v-if="isNR01">
				<div class="col-6">
					<b-form-group :label="getLabel('funcao')" :label-for="getKey('funcao')+'_id'">
						<b-form-input :id="getKey('funcao')+'_id'" :state="getState(getKey('funcao'))" v-model="row.funcao" trim maxlength="150"/>
						<b-form-invalid-feedback :state="getState(getKey('funcao'))" v-for="error in getErrors(getKey('funcao'))" :key="error">{{error}}</b-form-invalid-feedback>
					</b-form-group>
				</div>
			</div>
			

            <template #modal-footer>
                <b-button pill class="btn-base outline-primary-btn" @click="$bvModal.hide('beneficiario-import-form')">Cancelar</b-button>
                <b-button pill class="btn-base primary-btn" @click="salvar">Salvar</b-button>
            </template>	
        </b-modal>

        <b-modal id="beneficiario-import-validations-success" centered hide-footer hide-backdrop
		header-class="beneficiario-import-validations-sub-header" body-class="beneficiario-import-alert">
			<DynamicIcon icon="check" :classString="'alert-exclamation'"/>
            <span>Os dados do beneficiário estão corretos!</span>
        </b-modal>

        <b-modal id="beneficiario-import-validations-fall" centered hide-footer hide-
		header-class="beneficiario-import-validations-sub-header" body-class="beneficiario-import-alert">
			<DynamicIcon icon="exclamation" :classString="'alert-exclamation'"/>
            <span>Há erro(s) nos dados do beneficiários!</span>
        </b-modal>

        <b-modal id="beneficiario-import-success" centered hide-footer @hidden="close"
        header-class="beneficiario-import-sub-header" body-class="beneficiario-import-alert">
			<DynamicIcon icon="check" :classString="'alert-exclamation'" v-if="status == 'PRE_IMPORTING'"/>
            <span v-if="status == 'PRE_IMPORTING'">Suas alterações foram salvas</span>
            <DynamicIcon icon="not" :classString="'alert-exclamation'" v-if="status == 'INVALID'"/>
			<span v-if="status == 'INVALID'">Há erro(s) nos dados do beneficiário.<br> Por favor, corrija-o(s) antes de salvar.</span>
			<div class="mt-4 mb-2">
                <b-button pill class="btn-base primary-btn btn-modal" @click="close">Ok</b-button>
            </div>
        </b-modal>
    </div>	
</template>

<script>
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import EmpresaResource from "@/resources/EmpresaResource";
import headerFields from "../../ImportarBeneficiarios/config/header-colunas"
import {hasErrorsValidations} from "../../ImportarBeneficiarios/utils/importar-beneficiarios-utils"
import {translateValidations} from "@/util/TranslateUtils"
import {isString, isObject} from "@/util/utils"
import { maskPhoneNumber , maskCPF, maskCNPJ } from "@/util/StringUtils"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import Validations from "@/util/Validations";
import InputDate2 from "@/components/commons/Inputs/InputDate2"
import { getSexoOptions, getEstadoCivilOptions2, getParentescoOptions2, getTipoOptions2, addZero, addErrors } from "@/util/BeneficiarioUtils.js"


import moment from "moment-timezone"

export default {
	name: "ModalCorrigirErrosInesperadosForm",
	components:{
		DynamicIcon,
		InputDate2
	},
	props: {
		importacaoId: Number,
		line: Number
	},
	data() {
		return {
			fields: headerFields.filter(field => field.key != "line"),
			row: {
				empresaId: null,
				tipoBeneficiario: null,
				nome: null,
				cpf: null,
				cnpjFaturamento: null,
				errors : null
			},
			nr01: false,
			status: null,
			messageError: null,
			sexoOptions: getSexoOptions(),
            parentescoOptions: getParentescoOptions2(),
            estadoCivilOptions: getEstadoCivilOptions2 (),
			tipoOptions : getTipoOptions2()
		};
	},
	computed: { 
		isDependente ()  {
			return this.row.tipoBeneficiario == 'DEPENDENTE'
		},
		isNR01 ()  {
			return this.nr01
		}
	},
    methods: {
		salvar() {

			this.row.errors = null
			let row = {...this.row}

			row.cpf = addZero(row.cpf)
			row.cpfTitular = addZero(row.cpfTitular)
			row.cnpjFaturamento = addZero(row.cnpjFaturamento, 14)
			row.parentesco = this.getParentesco(row.parentesco)
			
			if(!row.empresaId) {
				this.row = addErrors(row, 'empresaId')
			}
			
			if(!row.tipoBeneficiario){
				this.row = addErrors(row, 'tipoBeneficiario')
			}

			if(row.nome == null || row.nome == "") {
				this.row = addErrors(row, 'nome')
			}

			if(row.cpf){
				this.messageError = Validations.cpf(row.cpf, true)
				if(this.messageError){
					this.row = addErrors(row, 'cpf', this.messageError)
				}
			}

			if(row.cpfTitular || row.tipoBeneficiario == "DEPENDENTE"){
				this.messageError = Validations.cpf(row.cpfTitular, true)
				if(this.messageError){
					this.row = addErrors(row, 'cpfTitular', this.messageError)
				}
			}

			if(!row.cnpjFaturamento || !Validations.validateCNPJ(row.cnpjFaturamento)){
				this.row = addErrors(row, 'cnpjFaturamento')
			}

			if(row.dataNascimento){
				row.dataNascimento = row.dataNascimento.substring(0, 10).split("-").reverse().join("/")
			}

			if(row.dataAdmissao) {
				row.dataAdmissao = row.dataAdmissao.substring(0, 10).split("-").reverse().join("/")
			}
			
			if(row.telefoneCelular){
				this.messageError = Validations.cellPhone(row.telefoneCelular, false, true)
				if(this.messageError){
					row = addErrors(row, 'telefoneCelular', this.messageError)	
				}
			}

			if(row.telefoneResidencial){
				this.messageError = Validations.telefone(row.telefoneResidencial, false, true)
				if(this.messageError){
					row = addErrors(row, 'telefoneResidencial', this.messageError)
				}
			}

			if(row.telefoneComercial){
				this.messageError = Validations.telefone(row.telefoneComercial, false, true)
				if(this.messageError){
					row = addErrors(row, 'telefoneComercial', this.messageError)	
				}
			}

			BeneficiarioImportacaoResource.salvarImportacao(row, {showLoader: true})
			.then(result => {
				this.status = result.status
				this.$bvModal.show('beneficiario-import-success')
			})
		},
		getState(key) {
			if (!this.row.errors || !this.row.errors.fieldErrors)
			{
				return
			}

			return !(this.row.errors.fieldErrors[key] && this.row.errors.fieldErrors[key].length)
		},
		getErrors(key) {
			if (!this.row.errors || !this.row.errors.fieldErrors || !this.row.errors.fieldErrors[key])
			{
				return []
			}

			return  this.row.errors.fieldErrors[key]
		},
		getLabel(key) {
			const result = headerFields.find(field => field.key == key)
			if(result)
				return result.label
		},
		getKey(_key) {
			const result = headerFields.find(field => field.key == _key)
			if(result)
				return result.key
		},
		validar() {
			BeneficiarioImportacaoResource.validarImportacao(this.row, {showLoader: true})
			.then(validation => {
				if (hasErrorsValidations(validation))
				{
					translateValidations(validation, "beneficiarioImportacaoEdition")
					this.row.errors = validation
					this.$bvModal.show('beneficiario-import-validations-fall')
				}
				else
				{
					this.row.errors = null
					this.$bvModal.show('beneficiario-import-validations-success')
				}
			})
		},
		close() {
			this.$bvModal.hide('beneficiario-import-success')
			this.$emit("updated", {} )
		},
		getParentesco(value) {
			if(!value)
				return null

			if(isObject(value))
				value = value?.value || ""
			
			value = value.replace(/\s/g, '')
			
			let result = this.parentescoOptions.find(elem => elem.value.toUpperCase() == value.toUpperCase())

			if(isObject(result))
				result = result?.value || ""

			return result
		},
		_isNR01(produtoId)
        {
            if(!produtoId || produtoId.length == 0)
            {
                this.nr01 = false
                return
            }

            const programaId = 16 // NR_01
            this.nr01 = false

			EmpresaResource.getProduto(programaId, produtoId, {showLoader: true})
			.then(result => {
				if(result)
				{	
					this.nr01 = result || false
				}
			}) 
			
        }
    },
	created() {
		BeneficiarioImportacaoResource.getLineImportacao(this.importacaoId, this.line, {showLoader: true})
		.then(row => {
			if (isString(row.errors)) {
				let errors = JSON.parse(row.errors)
				if (hasErrorsValidations(errors))
				{
					translateValidations(errors, "beneficiarioImportacaoEdition")
					row.errors = errors
				}
			}

			row.dataNascimento = row.dataNascimento ? moment.tz(row.dataNascimento, "DD/MM/YYYY", "America/Sao_Paulo").toISOString() : null
			row.genero = row.genero ? row.genero.charAt(0).toUpperCase() : null
			row.parentesco = this.getParentesco(row.parentesco)
			row.cpf = maskCPF(row.cpf)
			row.cpfTitular = maskCPF(row.cpfTitular)
			row.cnpjFaturamento = maskCNPJ(row.cnpjFaturamento)
			row.telefoneCelular = maskPhoneNumber(row.telefoneCelular)
			row.telefoneComercial = maskPhoneNumber(row.telefoneComercial)
			row.telefoneResidencial = maskPhoneNumber(row.telefoneResidencial)
			this.row = row
			this._isNR01(row.produto)
		})
	}
}
</script>

<style scoped>
.modal-header {
  border-bottom: none !important;
}
.modal-footer {
  border-top: none !important;
}

input, select{
    border: 1px solid #bbbec0 !important;
}

.validar-btn {
	color: white;
}
</style>

<style>

.editar-beneficiario-form {
    padding: 5% !important;
    letter-spacing: 0 !important;
    font-family: optum-sans !important;
    font-weight: 400 !important;
    color: rgb(90, 90, 90) !important;
    font-size: 0.895rem !important;
	display: block;
}

.beneficiario-import-alert {
	text-align: center;
}

.beneficiario-import-alert svg {
	height: 40px;
	width: 40px;
	vertical-align: middle !important;
    margin-bottom: 5px;
}

.beneficiario-import-alert span {
	margin-left: 15px;
}

.list-group.global-errors {
	margin-bottom: 15px;
}

.sub-title {
	font-family: optum-sans-bold !important;
	color: #002677 !important;
	font-size: 24px;
	font-weight: 700;
	line-height: 24px;
	letter-spacing: 0em;
	text-align: left;
	margin-left:1.3rem;
}

.span-required {
color:#C40000;
}
</style>